module.exports = __webpack_public_path__ + "img/altitude-resort-2.8ab47b9a.jpg";